import React from 'react';
import PropTypes from 'prop-types';

import './VodacomPreBanner.css';

const VodacomPreBanner = (props) => {
  return (
    <React.Fragment>
      <div className="additional-vas-banner-title" automationid="SalesLead_Div_VoadcomPreBannerTitle_0">
        <p className="banner-title">This deal includes:</p>
      </div>
      <div className="additional-vas-banner-container" automationid="SalesLead_Div_VoadcomPreBannerContainer_0">
        { 
          props.inclusions.map(inclusion => {
            return(
              <div key={inclusion}
                className="banner-item-container"
                automationid="SalesLead_Div_VoadcomPreBannerItemContainer_1">
                <span className="banner-desc-section-title" automationid="SalesLead_Span_VoadcomPreBannerDescTitle_0">
                  + {inclusion}
                </span>
              </div>
            )
          })
        }
      </div>
    </React.Fragment>
  )
}

VodacomPreBanner.propTypes = {
  inclusions: PropTypes.arrayOf(PropTypes.string)
};

export default VodacomPreBanner;